import { render, staticRenderFns } from "./CloneModal.vue?vue&type=template&id=92ff6ed2&scoped=true"
import script from "./CloneModal.vue?vue&type=script&lang=js"
export * from "./CloneModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ff6ed2",
  null
  
)

export default component.exports